"use strict";

exports.__esModule = true;
exports.css = css;

var _props = require("../props");

var _core = require("../core");

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const systemProps = (0, _core.compose)(_props.background, _props.border, _props.color, _props.flexbox, _props.grid, _props.layout, _props.other, _props.position, _props.shadow, _props.space, _props.transition, _props.typography);
const aliases = {};
const multiples = {};
const scales = {};
const transforms = {};
systemProps.propNames.forEach(propName => {
  const config = systemProps.config[propName];
  if (!config) return;

  if (config.properties) {
    multiples[propName] = [...config.properties];
  }

  if (config.transform) {
    transforms[propName] = config.transform;
  }

  if (config.scale) {
    scales[propName] = config.scale;
  }

  if (config.property && propName !== config.property) {
    aliases[propName] = config.property;
  }
});

function css(stylesOrFn) {
  return (theme = {}) => {
    if (!stylesOrFn) return {};
    const result = {};
    const rawStyles = typeof stylesOrFn === 'function' ? stylesOrFn(theme) : stylesOrFn;
    const styles = (0, _core.responsive)(rawStyles)(theme);

    for (const style in styles) {
      const styleValue = styles[style];

      if (styleValue && typeof styleValue === 'object') {
        result[style] = css(styleValue)(theme);
        continue;
      }

      const prop = (0, _lodash.default)(aliases, style, style);
      const scaleName = (0, _lodash.default)(scales, prop);
      const scale = (0, _lodash.default)(theme, scaleName, (0, _lodash.default)(theme, prop, {}));
      const transform = (0, _lodash.default)(transforms, prop, _lodash.default);
      const value = transform(scale, styleValue, styleValue);

      if (multiples[prop]) {
        const dirs = multiples[prop];

        for (let i = 0; i < Object.keys(dirs).length; i += 1) {
          result[dirs[i]] = value;
        }

        continue;
      }

      result[prop] = value;
    }

    return result;
  };
}